import { useEffect } from 'react';
import { useLocation, useNavigate } from 'react-router-dom';
import { useCmsEdit } from './CmsEditProvider';

/**
 * Lives inside <Router>. Gives the CMS runtime a navigate() function for
 * `cms:navigate` and reports every route change to the admin. Renders nothing.
 */
const CmsRouterBridge = () => {
  const cms = useCmsEdit();
  const navigate = useNavigate();
  const location = useLocation();

  useEffect(() => {
    if (!cms.requested) return;
    cms.attachRouter((path: string) => navigate(path), location.pathname);
  }, [cms.requested, cms.attachRouter, navigate, location.pathname]);

  useEffect(() => {
    if (!cms.enabled) return;
    cms.reportRoute(location.pathname);
  }, [cms.enabled, cms.reportRoute, location.pathname]);

  return null;
};

export default CmsRouterBridge;
